(ns practitest.frontend.common-old-fe.rbdnd
  (:require
    [goog.object :as go]
    [reagent.core :as reagent]
    ["react-beautiful-dnd" :refer [DragDropContext Draggable Droppable]]))

;; Adapt the React components
(def DragDropContext (reagent/adapt-react-class DragDropContext))
(def Draggable (reagent/adapt-react-class Draggable))
(def Droppable (reagent/adapt-react-class Droppable))

(defn draggable
  "`id`        - unique string id of the draggable.
   `ix`        - index of the draggable inside the droppable.
   `style-f`   - function returning style and accepting boolean indicating whether this draggable is being dragged.
   `disabled?` - boolean."
  [{:keys [id ix style-f disabled?] :or {disabled? false}} body]
  [Draggable
   {:draggable-id     id
    :key              id
    :index            ix
    :is-drag-disabled disabled?
    :children         (fn [provided snapshot]
                        (reagent/as-element
                          [:div
                           (merge
                             {:ref                                (go/get provided "innerRef")
                              :style                              (merge (style-f (go/get snapshot "isDragging"))
                                                                         (some-> (go/get provided "draggableProps")
                                                                                 (go/get "style")
                                                                                 (js->clj :keywordize-keys true)))
                              :data-react-beautiful-dnd-draggable (some-> (go/get provided "draggableProps")
                                                                          (go/get "data-react-beautiful-dnd-draggable"))}
                             (js->clj (go/get provided "dragHandleProps")))
                           body]))}])

(defn droppable
  "`id`        - unique string id of the droppable.
   `direction` - vertical or horizontal.
   `style-f`   - function returning style and accepting boolean indicating whether there is something dragging over this droppable.
   `title`     - title component."
  [{:keys [id direction style-f title] :or {direction "vertical"}} items]
  [Droppable
   {:droppable-id id
    :direction    direction
    :children     (fn [provided snapshot]
                    (reagent/as-element
                      [:div
                       title
                       [:div
                        (merge
                          {:ref   (go/get provided "innerRef")
                           :style (style-f (go/get snapshot "isDraggingOver"))}
                          (js->clj (go/get provided "droppableProps")))
                        (into [:<>] items)
                        (go/get provided "placeholder")]]))}])

(defn drag-drop-context
  "`on-drag-end` - function accepting three parameters: source, destination and draggable-id."
  [{:keys [on-drag-end]} body]
  [DragDropContext
   {:on-drag-end (fn [result]
                   (on-drag-end (js->clj (go/get result "source") :keywordize-keys true)
                                (js->clj (go/get result "destination") :keywordize-keys true)
                                (go/get result "draggableId")))}
   body])
